import { motion } from 'motion/react';
import { Container, Kicker } from './primitives';

export function Testimonial({ index = '07' }: { index?: string }) {
  return (
    <section id="customers" className="relative border-t border-border py-28 md:py-36">
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 -z-10 h-[420px]"
        style={{
          background:
            'radial-gradient(50% 100% at 50% 0%, color-mix(in oklch, var(--primary) 9%, transparent), transparent 70%)',
        }}
      />
      <Container>
        <Kicker index={index} label="Perché lo costruiamo" />

        <motion.figure
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 grid grid-cols-1 gap-12 lg:grid-cols-[120px_1fr] lg:gap-16"
        >
          <div className="flex items-start">
            <span className="text-[120px] font-light leading-none text-primary">“</span>
          </div>
          <div>
            <blockquote className="text-balance text-[34px] font-light leading-[1.2] tracking-tight md:text-[44px]">
              Non lo costruiamo perché è una feature facile da vendere. Lo costruiamo perché abbiamo visto
              troppi geometri chiudere la giornata alle nove di sera, <span className="text-primary">a
              rincorrere foto su WhatsApp</span> per un giornale che dovrebbe scriversi da solo.
            </blockquote>

            <figcaption className="mt-10 flex flex-wrap items-center gap-4">
              <div className="h-12 w-12 overflow-hidden rounded-full border border-input">
                <div
                  className="h-full w-full"
                  style={{
                    background:
                      'conic-gradient(from 140deg, oklch(0.66 0.15 245), oklch(0.45 0.15 255), oklch(0.78 0.11 195))',
                  }}
                />
              </div>
              <div>
                <div className="text-[14px] text-foreground">Dante Marramiero &amp; Matteo Angelozzi</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                  Fondatori · BOSS
                </div>
              </div>
              <span className="ml-auto hidden font-mono text-[10px] uppercase tracking-[0.22em] text-fg-disabled md:inline">
                fig. 02 — pilota in corso · Almacis · Pescara
              </span>
            </figcaption>
          </div>
        </motion.figure>
      </Container>
    </section>
  );
}
